import React from 'react';
import PropTypes from 'prop-types';

const formatDate = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  return date.toLocaleString('es-AR');
};

const ESTADO_ETIQUETA = {
  queued:       'En cola',
  processing:   'Procesando',
  sent:         'Enviado',
  delivered:    'Entregado',
  read:         'Leído',
  received:     'Recibido',
  sin_conexion: 'Sin conexión',
  failed:       'Fallido',
};

const ORIGEN_CONFIG = {
  automatico: { label: 'Automático', css: 'automatico' },
  manual:     { label: 'Manual',     css: 'manual'     },
};

function BadgeOrigen({ direction, origen }) {
  if (direction === 'incoming') {
    return <span className="wa-log-origen entrante">Entrante</span>;
  }
  const config = ORIGEN_CONFIG[origen];
  if (!config) return <span className="wa-log-origen">-</span>;
  return <span className={`wa-log-origen ${config.css}`}>{config.label}</span>;
}

function WhatsAppLogsTable({ logs, loading, onRefresh }) {
  return (
    <section className="wa-admin-card wa-admin-card-full">
      <header className="wa-admin-card-header">
        <h3 className="wa-admin-card-title">Logs de mensajes</h3>
        <button type="button" className="btn btn-outline-secondary btn-sm" onClick={onRefresh} disabled={loading}>
          {loading ? 'Actualizando...' : 'Actualizar'}
        </button>
      </header>

      <div className="wa-admin-card-body">
        {loading && (
          <div className="wa-loader-inline">
            <div className="spinner-border spinner-border-sm text-primary" role="status" />
            Actualizando logs...
          </div>
        )}

        {!loading && logs.length === 0 && (
          <div className="wa-empty-state">
            <i className="bi bi-inbox" aria-hidden="true" />
            <p>No hay logs de mensajes disponibles.</p>
          </div>
        )}

        {!loading && logs.length > 0 && (
          <div className="table-responsive">
            <table className="table table-hover align-middle wa-table">
              <thead>
                <tr>
                  <th>Telefono</th>
                  <th>Mensaje</th>
                  <th>Origen</th>
                  <th>Estado</th>
                  <th>Fecha</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((item) => (
                  <tr key={item.id || `${item.phone}-${item.timestamp}`}>
                    <td>{item.phone || '-'}</td>
                    <td className="wa-message-cell" title={item.message}>{item.message || '-'}</td>
                    <td>
                      <BadgeOrigen direction={item.direction} origen={item.origen} />
                    </td>
                    <td>
                      <span className={`wa-log-status ${(item.status || '').toLowerCase()}`}>
                        {ESTADO_ETIQUETA[item.status] || item.status || '-'}
                      </span>
                    </td>
                    <td>{formatDate(item.timestamp || item.updatedAt || item.createdAt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
}

BadgeOrigen.propTypes = {
  direction: PropTypes.string,
  origen: PropTypes.string,
};

BadgeOrigen.defaultProps = {
  direction: null,
  origen: null,
};

WhatsAppLogsTable.propTypes = {
  logs: PropTypes.arrayOf(PropTypes.object),
  loading: PropTypes.bool,
  onRefresh: PropTypes.func.isRequired
};

WhatsAppLogsTable.defaultProps = {
  logs: [],
  loading: false
};

export default WhatsAppLogsTable;
